import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistique-moderation-card',
  templateUrl: './statistique-moderation-card.component.html',
  styleUrls: ['./statistique-moderation-card.component.css']
})
export class StatistiqueModerationCardComponent implements OnInit {

  donneegraphe: any;
  constructor() {
    this.donneegraphe = {
      labels: ['11/06/2020', '12/06/2020', '13/06/2020', '14/06/2020'],
      datasets: [
        {
          label: 'Moderations Traiteés',
          data: [40, 110, 137, 50],
          fill: false,
          borderColor: '#3984b8'
        },
        {
          label: 'Echantillons Traités',
          data: [20, 100, 144, 22],
          fill: false,
          borderColor: '#b8b60e'
        },
        {
          label: 'Moderations Livrées',
          data: [20, 40, 21, 41],
          fill: false,
          borderColor: '#b813ad'
        },
      ]
    };
  }

  ngOnInit(): void {
  }
  selectData(event) {
    //this.messageService.add({severity: 'info', summary: 'Data Selected', 'detail': this.data.datasets[event.element._datasetIndex].data[event.element._index]});
  }

}
